import Collapse from './src'

Collapse.install = Vue => {
  Vue.component(Collapse.name, Collapse)
}

export default Collapse
